<template>
    <v-layout column>
        <v-flex xs12 class="notPrinted">
            <v-card>
                <v-layout>
                    <v-flex xs12 md3>
                        <v-btn block color="error" @click="backToOrder()">Back To Order</v-btn>
                    </v-flex>
                    <v-flex xs12 md6>
                        <h1 class="text-xs-center">Print Order Sheet</h1>
                    </v-flex>
                    <v-flex xs12 md3>
                        <v-btn block color="info" @click="triggerPrint()">Print</v-btn>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex xs12>
                        <v-layout>
                            <v-flex xs12 sm4 mx-4>
                                <v-autocomplete
                                    :items="stores"
                                    item-text="Name"
                                    item-value="ID"
                                    v-model="storeID"
                                    readonly
                                    label="Store"
                                    hint="Store"
                                ></v-autocomplete>
                            </v-flex>
                            <v-flex xs12 sm4 mx-4>
                                <v-autocomplete
                                    :items="departmentsInSelectedStore"
                                    item-text="Name"
                                    item-value="ID"
                                    v-model="departmentID"
                                    readonly
                                    label="Department"
                                    hint="Department"
                                ></v-autocomplete>
                            </v-flex>
                            <v-flex xs12 sm4 mx-4>
                                <v-text-field
                                    slot="activator"
                                    v-model="date"
                                    label="Order Date"
                                    hint="Order Date"
                                    readonly
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>
        <v-flex xs12>
            <v-card>
                <PrintableOrderSheet
                    :loading="loading"
                    :products="productsWithCategories"
                    :userEmail="userEmail"
                    :date="date"
                    :store="selectedStore"
                    :showCommeneField="false"
                    :showStockEntry="showStockEntry"
                    :isPrintPage=true
                ></PrintableOrderSheet>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import PrintableOrderSheet from "./PrintableOrderSheet.vue";
import auth from '@/services/auth';
import util from '@/services/util';
import orderUtil from '@/services/orderUtil';

export default {
    components: {
        PrintableOrderSheet
    },
    props: [
        'loading',
        'storeID',
        'departmentID',
        'date',
        'showStockEntry'
    ],
    data() {
        return {
            productsWithSuppliers: [],
            categoriesWithProducts: [],
        };
    },
    computed: {
        userEmail(){
            return this.$store.getters["authStore/getUserProfile"].Email;
        },
        stores() {
            return this.$store.state.storeStore.stores.filter(s => s.Active && auth.hasAccessToStore(s.ID)).sort(util.sortByName);
        },
        selectedStore(){
            return this.stores.find(s => s.ID == this.storeID);
        },
        departments() {
            return this.$store.state.departmentStore.departments.filter(d => d.Active && auth.hasAccessToDepartment(d.ID)).sort(util.sortByName);
        },
        departmentsInSelectedStore(){
            let departments = this.departments.filter(d => {
                if(!this.selectedStore){
                    return false;
                }

                if(!this.selectedStore.DepartmentIDs){
                    return false;
                }
                
                let selectedStoreContainsDepartment = this.selectedStore.DepartmentIDs.split(",").some(dID => dID == d.ID);
                if(!selectedStoreContainsDepartment){
                    return false;
                }

                return true;
            });

            return departments;
        },
        selectedDepartment(){
            return this.departmentsInSelectedStore.find(d => d.ID == this.departmentID);
        },
        categories() {
            return this.$store.state.categoryStore.categories.filter(c => c.Active);
        },
        products() {
            return this.$store.state.productStore.products.filter(p => p.Active);
        },
        suppliers(){
            return this.$store.state.supplierStore.suppliers.filter(s => s.Active);
        },
        storeSuppliers(){
            return this.$store.state.storeSupplierStore.storeSuppliers;
        },
        supplierProducts() {
            return this.$store.state.supplierStore.products.supplierProducts;
        },
        productsWithCategories(){
            return this.productsWithSuppliers.map(p => {
                let product = Object.assign({}, p);

                let categoryID = product.CategoryID;
                if(categoryID){
                    let category = this.categories.find(c => c.ID == categoryID);
                    product.Category = category;
                }

                return product;
            }).filter(p => p.Category).sort(util.sortByName);
        }
    },
    methods: {
        backToOrder(){
            this.$emit("onCancel");
        },
        triggerPrint(){
            window.print();
        },
        loadProductsAndCategories(){
            let result = orderUtil.getProductsAndCategories(this.storeSuppliers, this.suppliers, this.storeID, this.date, this.categories, this.departmentID, this.products);

            this.productsWithSuppliers = result.productsWithSuppliers;
            this.categoriesWithProducts = result.categoriesWithProducts;
        },
    },
    created(){
        this.loadProductsAndCategories();
    }
};
</script>

<style>
    
</style>